import * as React from "react";
import { motion } from "motion/react";

const Icon = (props: React.SVGProps<SVGSVGElement> & { state?: "active" | "inactive" }) => {
  const { state = "active" } = props;

  const topFaceColor = state === "active" ? "var(--cube-active)" : "var(--cube-inactive)";

  return (
    <svg width="74" height="85" viewBox="0 0 74 85" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0)">
        <motion.rect
          width="67.7329"
          height="120.433"
          transform="matrix(0.866025 0.5 -0.866025 0.5 26.918 -7.17984)"
          initial={{ fill: topFaceColor, opacity: 1 }}
          animate={{ fill: topFaceColor, opacity: 1 }}
          transition={{ duration: 0.5, ease: [0.33, 1, 0.68, 1] }}
        />
      </g>
      <g clipPath="url(#clip1)">
        <rect
          width="138.168"
          height="120.433"
          transform="matrix(2.20305e-08 1 -0.866025 0.5 74.5312 -62.8766)"
          fill="#003875"
        />
      </g>
      <g clipPath="url(#clip2)">
        <rect
          width="67.7329"
          height="120.433"
          transform="matrix(0.866025 0.5 -2.20305e-08 1 -11.0469 -29.0957)"
          fill="#000F21"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="42.2275"
            height="42.2275"
            fill="white"
            transform="matrix(0.866025 0.5 -0.866025 0.5 36.5703 0)"
          />
        </clipPath>
        <clipPath id="clip1">
          <rect
            width="42.2275"
            height="42.2275"
            fill="white"
            transform="matrix(2.20305e-08 1 -0.866025 0.5 73.1406 21.114)"
          />
        </clipPath>
        <clipPath id="clip2">
          <rect
            width="42.2275"
            height="42.2275"
            fill="white"
            transform="matrix(0.866025 0.5 -2.20305e-08 1 0 21.113)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Icon;
